module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTI0IDEwLjY0aC0xOC4yNHYtNC4yNGwtNS43NiA1Ljc2IDUuNzYgNS43NnYtNC4yNGgxOC4yNHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-left.svg
// module id = JREx
// module chunks = 0